// Types
import type { ObjectItem } from '@/types'

const URLParams = (obj: ObjectItem) => {
	return new URLSearchParams(obj).toString()
}

export default URLParams
